module.exports = __webpack_public_path__ + "68d81abb.svg";